import { FC } from 'react';
import { useAssetsCssProperties } from './assets';
import { useMotion } from '../../common';

import './style.scss';

export const Motion: FC = () => {
  const { motionRef, showImage } = useMotion({
    loading: 2,
    MOTION_REAL_HEIGHT: 900,
    MOTION_REAL_WIDTH: 1100,
  });

  const assetsCssProperties = useAssetsCssProperties();

  return (
    <div className="motion-tips" ref={motionRef} style={showImage ? assetsCssProperties : {}}>
      <div className="motion-tips-layer-0">
        <div className="motion-tips-layer-27">
          <div className="motion-tips-layer-27-scale">
            <div className="motion-tips-layer-27-opacity">
              <div className="motion-tips-layer-27-content">
                <div className="motion-tips-layer-26">
                  <div className="motion-tips-layer-26-position">
                    <div className="motion-tips-layer-26-opacity">
                      <div className="motion-tips-layer-26-rotation">
                        <div className="motion-tips-layer-26-content"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="motion-tips-layer-25">
                  <div className="motion-tips-layer-25-position">
                    <div className="motion-tips-layer-25-opacity">
                      <div className="motion-tips-layer-25-rotation">
                        <div className="motion-tips-layer-25-content"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="motion-tips-layer-24">
                  <div className="motion-tips-layer-24-position">
                    <div className="motion-tips-layer-24-scale">
                      <div className="motion-tips-layer-24-opacity">
                        <div className="motion-tips-layer-24-content"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="motion-tips-layer-23">
                  <div className="motion-tips-layer-23-position">
                    <div className="motion-tips-layer-23-scale">
                      <div className="motion-tips-layer-23-opacity">
                        <div className="motion-tips-layer-23-content"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="motion-tips-layer-19">
                  <div className="motion-tips-layer-19-opacity">
                    <div className="motion-tips-layer-19-content">
                      <div className="motion-tips-layer-22">
                        <div className="motion-tips-layer-22-opacity">
                          <div className="motion-tips-layer-22-content"></div>
                        </div>
                      </div>
                      <div className="motion-tips-layer-21">
                        <div className="motion-tips-layer-21-opacity">
                          <div className="motion-tips-layer-21-content"></div>
                        </div>
                      </div>
                      <div className="motion-tips-layer-20">
                        <div className="motion-tips-layer-20-opacity">
                          <div className="motion-tips-layer-20-content"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="motion-tips-layer-18">
          <div className="motion-tips-layer-18-scale">
            <div className="motion-tips-layer-18-opacity">
              <div className="motion-tips-layer-18-content">
                <div className="motion-tips-layer-17">
                  <div className="motion-tips-layer-17-position">
                    <div className="motion-tips-layer-17-opacity">
                      <div className="motion-tips-layer-17-rotation">
                        <div className="motion-tips-layer-17-content"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="motion-tips-layer-16">
                  <div className="motion-tips-layer-16-position">
                    <div className="motion-tips-layer-16-opacity">
                      <div className="motion-tips-layer-16-rotation">
                        <div className="motion-tips-layer-16-content"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="motion-tips-layer-15">
                  <div className="motion-tips-layer-15-position">
                    <div className="motion-tips-layer-15-scale">
                      <div className="motion-tips-layer-15-opacity">
                        <div className="motion-tips-layer-15-content"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="motion-tips-layer-14">
                  <div className="motion-tips-layer-14-position">
                    <div className="motion-tips-layer-14-scale">
                      <div className="motion-tips-layer-14-opacity">
                        <div className="motion-tips-layer-14-content"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="motion-tips-layer-10">
                  <div className="motion-tips-layer-10-opacity">
                    <div className="motion-tips-layer-10-content">
                      <div className="motion-tips-layer-13">
                        <div className="motion-tips-layer-13-opacity">
                          <div className="motion-tips-layer-13-content"></div>
                        </div>
                      </div>
                      <div className="motion-tips-layer-12">
                        <div className="motion-tips-layer-12-opacity">
                          <div className="motion-tips-layer-12-content"></div>
                        </div>
                      </div>
                      <div className="motion-tips-layer-11">
                        <div className="motion-tips-layer-11-opacity">
                          <div className="motion-tips-layer-11-content"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="motion-tips-layer-9">
          <div className="motion-tips-layer-9-scale">
            <div className="motion-tips-layer-9-opacity">
              <div className="motion-tips-layer-9-content">
                <div className="motion-tips-layer-8">
                  <div className="motion-tips-layer-8-position">
                    <div className="motion-tips-layer-8-opacity">
                      <div className="motion-tips-layer-8-rotation">
                        <div className="motion-tips-layer-8-content"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="motion-tips-layer-7">
                  <div className="motion-tips-layer-7-position">
                    <div className="motion-tips-layer-7-opacity">
                      <div className="motion-tips-layer-7-rotation">
                        <div className="motion-tips-layer-7-content"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="motion-tips-layer-6">
                  <div className="motion-tips-layer-6-position">
                    <div className="motion-tips-layer-6-scale">
                      <div className="motion-tips-layer-6-opacity">
                        <div className="motion-tips-layer-6-content"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="motion-tips-layer-5">
                  <div className="motion-tips-layer-5-position">
                    <div className="motion-tips-layer-5-scale">
                      <div className="motion-tips-layer-5-opacity">
                        <div className="motion-tips-layer-5-content"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="motion-tips-layer-1">
                  <div className="motion-tips-layer-1-opacity">
                    <div className="motion-tips-layer-1-content">
                      <div className="motion-tips-layer-4">
                        <div className="motion-tips-layer-4-opacity">
                          <div className="motion-tips-layer-4-content"></div>
                        </div>
                      </div>
                      <div className="motion-tips-layer-3">
                        <div className="motion-tips-layer-3-opacity">
                          <div className="motion-tips-layer-3-content"></div>
                        </div>
                      </div>
                      <div className="motion-tips-layer-2">
                        <div className="motion-tips-layer-2-opacity">
                          <div className="motion-tips-layer-2-content"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
